module.exports = "//img1.rrcimg.com/_next/static/src/assets/xa_3Ygyt.png";